import React, { useEffect, useState } from "react";
import HorizontalCard from "../../components/card/HorizontalCard";
import PageBanner from "../../components/PageBanner";
import Pagination from "../../components/Pagination";
import BannerService from "../../services/banner";
import ArticleService from "../../services/article";
import { useParams } from "react-router-dom";
import { articleSize } from "../../configs/pageSize";

export default function Article() {
  let [articleData, setArticleData] = useState(null);
  let [meta, setMeta] = useState({});
  const [page, setPage] = useState(1);
  // eslint-disable-next-line
  const [pageSize, setPageSize] = useState(articleSize);
  let [articleBanner, setArticleBanner] = useState([]);
  let { lang } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
    getArticleBanner();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getArticleData();

    // eslint-disable-next-line
  }, [page, pageSize]);

  //return lang function
  useEffect(() => {
    if (lang !== "th" && lang !== "en") {
      window.open(`${process.env.REACT_APP_WEB_URL}/th`, "_self");
    }
  });

  const getArticleBanner = async () => {
    try {
      let res = await BannerService.getBanner(4);
      setArticleBanner(res);
    } catch {
      console.error();
    }
  };

  const getArticleData = async () => {
    try {
      let [res, meta] = await ArticleService.getArticle({
        page: page,
        pageSize: pageSize,
      });
      setArticleData(res);
      setMeta(meta);
    } catch {
      console.error();
    }
  };

  const bannerText = [{ name: "Article", href: "/article" }];

  return (
    <div id="resource" className="pt-[135px] lg:pt-[0px]">
      <PageBanner
        text_th={"บทความความรู้"}
        text_en={"Article"}
        banner={articleBanner.banner}
        bannerText={bannerText}
        lang={lang}
      />

      <div className="section">
        <div className="page-container">
          {/* นัดหมาย */}
          <div className="mt-[92px] mb-[300px]">
            <h1 className="text-[28px] xl:text-[32px] text-left">
              Health Update
            </h1>

            <div className="flex flex-col gap-[20px] mt-[38px]">
              {articleData &&
                articleData.map((item, i) => (
                  <HorizontalCard
                    data={item}
                    key={i}
                    lang={lang}
                    page={"article"}
                  />
                ))}
            </div>

            {articleData && (
              <Pagination
                length={meta?.pagination?.pageCount ?? ""}
                selected={page}
                function={(i) => {
                  setPage(i);
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
